import React, { Component } from 'react'
import { connect } from 'react-redux'
import { actions } from 'react-redux-form'
import { Grid, Row, Col } from 'react-bootstrap'
import EditBrandForm from './brand-edit-form';
import BackLink from '../../../../common/back-link/index'
import PageTitle from "../../../../common/page-title/index";
import { getBrand } from '../../../../../actions/brands';
import { getCategories } from '../../../../../actions/categories';
import { initialStates } from '../../../../../initialStates';

class EditBrand extends Component {
  constructor(props){
    super(props);
  }

  componentWillMount() {
    const id = +this.props.match.params.id;

    if (id){
      this.props.dispatch(getBrand(id));
    }

    this.props.dispatch(getCategories('', 'INITIALIZE_ADD_BRAND'));
  }

  componentWillUnmount(){
    this.props.dispatch(actions.load('deep.admin_brand', initialStates.admin_brand));
    this.props.dispatch({ type: 'CLEAR_EDIT_BRAND' });
  }

  render(){
    return(
      <Grid bsClass="container" fluid className="product-brands">
        <Row>
          <Col lg={12}>
            <BackLink href="/admin/brands"/>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <PageTitle>Add/Edit brand</PageTitle>
            <EditBrandForm brand={this.props.brand}/>
          </Col>
        </Row>
      </Grid>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    brand: state.brands.brand,
    fetched: state.brands.fetched,
    fetching: state.brands.fetching,
  };
};

export default connect(mapStateToProps)(EditBrand);



// WEBPACK FOOTER //
// ./src/components/admin/products/brands/edit/index.jsx